// eslint-disable-next-line jira/restricted/react-component-props
import React, { forwardRef, type ReactElement, type ComponentProps, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { type ButtonProps } from '@atlaskit/button';
import AkTooltip from '@atlaskit/tooltip';
import type AsyncIcon from '@atlassian/jira-common-components-async-icon';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';
import { TriggerButtonContainer } from './styled';

type Props = {
	issueType: string;
	icon: ReactElement<ComponentProps<typeof AsyncIcon>>;
	onClick: (event: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
} & ButtonProps;

const TriggerButton = forwardRef<HTMLAnchorElement, Props>(
	({ issueType, icon, onClick, ...props }, ref) => {
		const { formatMessage } = useIntl();

		return (
			<TriggerButtonContainer>
				<AkTooltip
					/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
					testId="issue.views.issue-base.foundation.change-issue-type.tooltip"
					position="top"
					content={formatMessage(messages.changeType, {
						issueType,
					})}
					delay={0}
				>
					<Button
						{...props}
						/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
						testId="issue.views.issue-base.foundation.change-issue-type.button"
						aria-label={formatMessage(messages.changeType, {
							issueType,
						})}
						spacing="compact"
						appearance="subtle"
						onClick={onClick}
						iconBefore={icon}
						ref={ref}
						interactionName="auto-generated.issue.views.issue-base.foundation.change-issue-type.button.button"
					/>
				</AkTooltip>
			</TriggerButtonContainer>
		);
	},
);

export default TriggerButton;
